<script setup>
import MemberDropdown from './MemberDropdown.vue';
import { useAuthStore } from '@/stores/auth'
import { storeToRefs } from 'pinia';
import { useGamesStore } from '@/stores/games';
import { domainLogos } from '@/domainsLogos'; 
import { computed } from 'vue' 
const authStore = useAuthStore()
const games = useGamesStore()
const { getUser } = storeToRefs(authStore)
const { getCategories, getNewGames } = storeToRefs(games)
const currentDomain = window.location.hostname
const defaultLogo = domainLogos[currentDomain]
const hasLiveCasino = computed(() =>
  getCategories.value.some(cat => cat.nm?.toLowerCase() == 'live casino')
);
</script>

<template>
    <header id="header" class="bg-header-mobile">
        <div class="grid grid-cols-3 py-3 px-4">
            <div class="relative" v-if="getUser?.fixtureJackpot">
                <img src="/winn.svg" class="w-6 h-6 absolute  top-[-10px] left-[-10px]"/>
                <div class="max-w-max rounded-2xl border border-white/25 px-2.5 py-1.5">
                    <RouterLink to="/jackpot">
                        <div class="text-[12px] font-extrabold text-white">{{$t('header.8')}}</div>
                    </RouterLink>
                </div>
            </div>
            <div v-else>
                <div class="max-w-max rounded-2xl border border-white/25 px-2.5 py-1.5">
                    <div class="text-[12px] font-extrabold text-white">{{$t('header.1')}}</div>
                </div>
            </div>
            <div class="flex justify-center">
                <RouterLink to="/">
                    <div 
                        class="hm-Logo default" 
                        v-if="!getUser?.logo" 
                        :style="{ backgroundImage: `url(${defaultLogo})` }" 
                    />
                    <img class="hm-Logo" v-else :src="getUser.logo" />
                </RouterLink>
            </div>

            <div class="flex justify-end" v-if="getUser">
                <MemberDropdown />
            </div>
            <div v-else class="flex justify-end items-center" >
                <RouterLink class="flex flex-col items-center"  to="/login">
                    <div class="hm-MemberMenuIcon" />
                    <span class="text-sm text-white">{{ $t('app.22') }}</span>
                </RouterLink>
            </div>
        </div>

        <nav class="flex justify-between md:justify-center md:gap-10 px-4">
            <RouterLink class="hm-Link py-3.5" to="/">{{$t('header.2')}}</RouterLink>
            <RouterLink class="hm-Link py-3.5" to="/sports">{{$t('header.6')}}</RouterLink>
            <RouterLink class="hm-Link py-3.5" to="/in-play">{{$t('header.3')}}</RouterLink>
            <RouterLink class="hm-Link py-3.5" to="/casino" v-if="getCategories.length>0">
                <div class="relative">
                    {{$t('header.5')}}
                    <!-- <img v-if="getNewGames.length" src="/sh.png" class="w-6 h-6 absolute right-[-16px] top-[-16px]"/>  -->
                </div>
            </RouterLink>
             <RouterLink class="hm-Link py-3.5" to="/live-casino" v-if="hasLiveCasino"> {{$t('header.7')}} </RouterLink>
        </nav>
    </header>
</template>

<style scoped>
.hm-Logo.default {
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
}

.hm-Padd {
    padding: 0 calc((100vw - 1450px)/2);
}

.hm-Link {
    @apply inline-flex items-center border-b-2 border-transparent text-white text-[13px] font-bold;
}
.hm-Link.router-link-exact-active {
    color: var(--hm-selected);
    border-color: var(--hm-selected);
}
.hm-MemberMenuIcon {
     mask-image: url('/user.svg');
    background-color: white;
    mask-size: 20px 20px;
    /* width: 12px;
    height: 12px; */
    width: 20px;
    height: 20px;
}
</style>
